import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { password }, { withCredentials: true });
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Incorrect password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050914] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 hero-mesh" />
      <div className="absolute inset-0 noise-overlay" />
      <div className="relative w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-white/50 hover:text-white mb-8 text-sm transition-colors" data-testid="admin-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to website
        </a>
        <div className="bg-[#0B1221] border border-white/10 rounded-2xl p-8 lg:p-10 backdrop-blur-xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-full border border-white/15 bg-white/5 flex items-center justify-center">
              <Lock className="w-4 h-4 text-white" />
            </div>
            <div>
              <h1 className="font-display text-xl font-medium tracking-tight text-white">Digitize CMS</h1>
              <p className="text-[11px] tracking-[0.25em] uppercase text-white/40 mt-1 font-bold">Content Management</p>
            </div>
          </div>
          <form onSubmit={handleLogin} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block text-[11px] uppercase tracking-[0.25em] text-white/45 font-bold mb-3">Admin Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="w-full bg-transparent border-0 border-b border-white/15 text-white placeholder-white/30 py-3 px-0 focus:border-white focus:outline-none transition-colors"
                autoFocus
                data-testid="admin-password-input"
              />
            </div>
            {error && <p className="text-red-400 text-sm" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 bg-white text-[#050914] font-semibold rounded-full hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200 disabled:opacity-60"
              data-testid="admin-login-button"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
